<template>
  <div>
    <breadcrumbs home="Payment method"/>

    <v-card flat width="100%">
      <v-form v-model="valid" ref="form">
        <v-container class="px-6 pt-8 purtrak-scrollable" fluid>

          <v-row dense>
            <v-col cols="12" sm="6" md="5">
              <v-text-field label="Name" v-model="paymentMethod.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" :counter="100" outlined dense/>
            </v-col>
            <v-col cols="2" lg="1">
              <v-checkbox label="Active" v-model="paymentMethod.active" class="mt-1"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" lg="2">
              <v-checkbox label="Credit card" v-model="paymentMethod.creditCard" class="mt-1"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'SettingsPaymentMethodsEdit',
  mixins: [confirmLeave],
  props: {
    paymentMethodId: {type:String, required:false}
  },
  data() {
    return {
      paymentMethod: {active:true,name:'',creditCard:false},
      valid: true,
      dirty: false,
      saving: false
    }
  },
  watch: {
    paymentMethod: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },

  async created() {
    if (this.paymentMethodId) {
      const results = await this.$apiCall(`query PaymentMethodsEdit($id:ID!) {
                                                paymentMethod(id:$id) {
                                                  id,name,active,creditCard
                                                }
                                              }`,
                                          {id:this.paymentMethodId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.paymentMethod = results.data.paymentMethod;
      this.$nextTick(() => this.dirty = false);
    }
  },
  mounted() {
    this.$refs.form.validate();
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.saving = true;
      const results = await this.$apiCall(`mutation PaymentMethodsEdit($input: PaymentMethodInput!) {
                                             paymentMethodCrupdate(input:$input) {id}
                                           }`,
                                          {input:this.paymentMethod})
      this.saving = false;
      if (results.error)
        return;

      this.$nextTick(() => {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.paymentMethodId?'Updated':'Created'} payment method ${this.paymentMethod.name}`});
      });
    },
  }
}
</script>